import React from 'react';
import { ArrowRight, Quote } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
interface Study {
  client: string;
  sector: string;
  size: string;
  challenge: string;
  work: string;
  outcomes: string[];
  quote?: string;
  accent: string;
}
const studies: Study[] = [{
  client: 'Bowen Buchbinder Vilensky',
  sector: 'Legal',
  size: '15+ employees',
  challenge: 'Urgently rebuild the environment and establish secure remote capability.',
  work: 'New private cloud environment, managed support, two-factor authentication, backup and Australian data-centre replication.',
  outcomes: ['Staff access achieved five days after engagement.', 'Replication across two Australian data-centre locations.'],
  quote: 'The practice manager reported that CT Group delivered what was promised, within the urgent timeframe and budget.',
  accent: '#D2223D'
}, {
  client: 'Harrier Human Capital',
  sector: 'Human Resources',
  size: '80+ users',
  challenge: 'Replace ageing infrastructure with a more mobile, predictable and scalable cloud environment.',
  work: 'Private data-centre hosting, virtualisation, hosted exchange, terminal services and managed support.',
  outcomes: ['Project completed in under 45 days.', 'Less than two business hours of reported user downtime.'],
  accent: '#57578E'
}, {
  client: 'Williams & Hughes',
  sector: 'Legal Services',
  size: '35 users',
  challenge: 'Replace fragmented systems and improve document control, automation and firm-wide efficiency.',
  work: 'Virtualised infrastructure, document management, practice-system integration and standardised desktops.',
  outcomes: ['Reported return on investment in under 12 months.'],
  quote: 'The practice manager described the implementation as thorough, professional and completed with minimal disruption.',
  accent: '#0AA77E'
}];
export function CaseStudies() {
  return <Section id="outcomes" className="bg-surface-2" ariaLabel="Client outcomes" data-id="element-153">
      <SectionHeading eyebrow="Published client outcomes" title="Proof specific enough to examine." body="These historical CT Group case studies show the business situation, work completed and result reported at the time." data-id="element-154" />

      <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3" data-id="element-155">
        {studies.map(s => <article key={s.client} className="flex flex-col overflow-hidden rounded-card border border-border bg-white shadow-sm transition-all duration-300 ease-smooth hover:-translate-y-1.5 hover:shadow-lg" data-id="element-156">
            <div className="h-1 w-full" style={{
          background: s.accent
        }} aria-hidden data-id="element-157" />
            <div className="flex flex-1 flex-col p-6" data-id="element-158">
              <div className="flex items-center gap-2" data-id="element-159">
                <span className="rounded-full px-3 py-1 text-[12px] font-bold" style={{
              background: `${s.accent}14`,
              color: s.accent
            }} data-id="element-160">
                  {s.sector}
                </span>
                <span className="text-[12px] font-medium text-slate" data-id="element-161">
                  {s.size}
                </span>
              </div>
              <h3 className="mt-3 font-display text-[19px] font-bold leading-snug text-navy" data-id="element-162">
                {s.client}
              </h3>

              <div className="mt-4 space-y-3 text-[14px] leading-relaxed" data-id="element-163">
                <p data-id="element-164">
                  <span className="font-bold text-ink" data-id="element-165">Challenge. </span>
                  <span className="text-slate" data-id="element-166">{s.challenge}</span>
                </p>
                <p data-id="element-167">
                  <span className="font-bold text-ink" data-id="element-168">Work. </span>
                  <span className="text-slate" data-id="element-169">{s.work}</span>
                </p>
              </div>

              <ul className="mt-4 space-y-2" data-id="element-170">
                {s.outcomes.map(o => <li key={o} className="rounded-lg bg-surface-3 px-3 py-2 text-[13.5px] font-semibold text-ct-deep" data-id="element-171">
                    {o}
                  </li>)}
              </ul>

              {s.quote && <blockquote className="mt-4 flex gap-2 border-l-2 pl-3 text-[14px] italic leading-relaxed text-ink" style={{
            borderColor: s.accent
          }} data-id="element-172">
                  <Quote className="h-4 w-4 flex-shrink-0" style={{
              color: s.accent
            }} aria-hidden data-id="element-173" />
                  {s.quote}
                </blockquote>}

              <p className="mt-auto pt-5 text-[11px] font-semibold uppercase tracking-wide text-slate/60" data-id="element-174">
                Published historical CT Group case study
              </p>
            </div>
          </article>)}
      </div>

      <div className="mt-10 text-center" data-id="element-175">
        <a href="#" className="inline-flex items-center gap-1.5 font-display text-[16px] font-bold text-ct-deep transition-colors hover:text-ct-cyan" data-id="element-176">
          View all client outcomes
          <ArrowRight className="h-4 w-4" aria-hidden data-id="element-177" />
        </a>
      </div>
    </Section>;
}